module.exports = __webpack_public_path__ + "img/d2025sj-btn.8157dfee.png";